module.exports = {
  "notification": {
    notificationManager: "通知管理",
    "deleteNotificationHint": "删除该通知将不可恢复，确定吗？",
    tenantName: "租户",
    "tenantNameHint2": "请选择租户",
    notificationTitle: "通知标题",
    notificationTitleHint: "请输入通知标题",
    notificationType: "通知类型",
    notificationTypeHint: "请输入通知类型",
    notificationStatus: "通知状态",
    notificationStatusHint: "请选择通知状态",
    dfs: "待发送",
    yfs: "已发送",
    ych: "已撤回",
    saveDraft: "存草稿",
    draft: "草稿",
    notificationList: "通知列表",
    notificationSendTime: "通知发送时间",
    notificationSendTimeHint: "请选择通知发送时间",
    notificationScope: "通知范围",
    notificationScopeHint: "请选择通知范围",
    addNotification: '新增通知',
    viewNotification: "查看通知",
    editNotification: "编辑通知",
    notificationInfo: "通知信息",
    messageNotification: "消息通知",
    messageNotification1: "管理端推送",
    messageNotification2: "公众号",
    messageNotification3: "短信",
    notificationOrg: "通知组织",
    notificationRole: "通知角色",
    notificationUser: "通知人员",
    notificationUserHint: "请选择接收通知的人员",
    "excludingOrg": "排除组织",
    "excludingRole": "排除角色",
    "excludingPeople": "排除人员",
    "excludingPeopleHint": "请选择排除人员",
    notificationContent: "通知内容",
    notificationContentHint: "请输入通知内容",
    "saveOnly": "仅保存",
    "saveAndPublish": "保存并发送",
    send: "发送",
    sendNow: "立即发送",
    timedTransmission: "定时发送",
    myNotification: "我的消息",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/notification/zh-CN.js